var map = {
	"./chris150-bd.png": 80054,
	"./chris200-bd.png": 50663,
	"./coin10-bd.png": 92184,
	"./coin100-bd.png": 49175,
	"./coin15-bd.png": 16178,
	"./coin20-bd.png": 93695,
	"./coin30-bd.png": 37417,
	"./coin5-bd.png": 48059,
	"./coin50-bd.png": 1922
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45770;